<template>
  <div>
    <v-card class="mx-auto" flat width="100%" max-width="680px">
      <v-form ref="form" v-model="formValid">
        <v-card flat class="mt-2">
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <FieldValue
                    :Text="
                      $store.state.eventInfo.EventId == 2063
                        ? 'Team Name'
                        : 'Company Name'
                    "
                    :Value="$store.state.eventInfo.VendorName"
                  ></FieldValue>
                </v-col>
                <v-col cols="12" md="12">
                  <FieldValue
                    Text="Email Id"
                    :Value="$store.state.eventInfo.VendorEmail"
                  ></FieldValue>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="appData.company_address"
                    :label="
                      $store.state.eventInfo.EventId == 2063
                        ? 'As a team, what does breaking limits mean to you? *'
                        : 'Company Address'
                    "
                    outlined
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  v-if="$store.state.eventInfo.EventId !== 2063"
                >
                  <v-text-field
                    v-model="appData.company_phone_no"
                    label="Company Phone No *"
                    outlined
                    maxlength="12"
                    :rules="[rules.req]"
                    @keypress="filterNum(event)"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  v-if="$store.state.eventInfo.EventId == 2063"
                >
                  <v-select
                    v-model="appData.company_phone_no"
                    label="Select Festival *"
                    outlined
                    :items="items"
                    :rules="[rules.req]"
                  >
                  </v-select>
                </v-col>
                <!-- <v-col v-if="$store.state.eventInfo.EventId == 2063">
                  <ViewSchedule Text="View Festival Schedule" Type="btn" />
                </v-col> -->
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="appData.vendor_name"
                    :label="
                      $store.state.eventInfo.EventId == 2063
                        ? 'Team Co-ordinator (Point of Contact for Team) *'
                        : 'Contact Person Name *'
                    "
                    :rules="[rules.req]"
                    outlined
                    @keypress="filterChar(event)"
                    hide-details
                  ></v-text-field>

                  <div style="color: red" v-if="$store.state.eventInfo.EventId == 2063">
                    All information regarding the criiio Cricket Festivals will
                    be sent to this individual.
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="appData.vendor_contact_no"
                    label="Contact No. *"
                    outlined
                    maxlength="10"
                    :rules="[rules.req]"
                    @keypress="filterNum(event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="appData.vendor_doc_type"
                    :items="[
                      'Aadhaar Card',
                      'Voter ID Card',
                      'Driving Licence',
                      'Passport',
                    ]"
                    label="ID Proof Type *"
                    dense
                    outlined
                    :rules="[rules.req]"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="appData.vendor_doc_no"
                    label="ID Proof Number *"
                    dense
                    outlined
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
              </v-row> -->
              <div>
                <v-checkbox v-model="cbTnC" label="I accept Term & Conditions.">
                </v-checkbox>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              class="pl-4 pr-4"
              x-large
              color="success"
              :disabled="!formValid"
              @click="createprofile"
            >
              <v-icon left>mdi-content-save-move</v-icon> Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-card>

    <v-snackbar top v-model="alert.show" :color="alert.color">
      {{ alert.msg }}
    </v-snackbar>

    <v-overlay :value="overlay" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="900px"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <!-- <v-card-title style="font-size:1.1rem;">
          Term and Conditions
        </v-card-title>
        <v-divider></v-divider> -->
        <v-card-text>
          <div v-html="tchtml"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldValue from "../components/application/FieldValue";
//import ViewSchedule from "../components/common/ViewSchedule.vue";
import axios from "axios";
export default {
  layout: "login",
  components: { FieldValue },
  data() {
    return {
      tchtml: "",
      alert: {
        color: "success",
        msg: "",
        show: false,
      },
      overlay: false,
      cbTnC: true,
      appData: {
        vendor_id: "",
        event_id: "",
        venue_id: "",
        vendor_name: "",
        company_address: "",
        company_phone_no: "",
        vendor_contact_no: "",
        vendor_doc_type: "",
        vendor_doc_no: "",
      },
      formValid: false,
      comp_id: "",
      dialog: false,
      isLoading: false,
      rules: {
        req: (val) => (val !== null && val !== "") || "Required!",
        email: (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      },
      items: [],
    };
  },

  async mounted() {
    await axios
      .get(
        this.$apiPhotoPath +
          "/assets/" +
          this.$store.state.eventInfo.EventUrl +
          "/tnc/local.html"
      )
      .then((response) => {
        this.tchtml = response.data;
      })
      .catch();
    this.$store.commit(
      "setPageTitle",
      this.$store.state.eventInfo.EventId == 2063
        ? "Team Details"
        : "Company Details"
    );
    this.txtcompanyname = this.$store.state.eventInfo.VendorName;
    this.txtcompanypersonemail = this.$store.state.eventInfo.VendorEmail;
    if (this.$store.state.eventInfo.VenueId == 2120) {
      this.items = [
        "Festival 1 - Sep 20 & 21, 2025",
        "Festival 2 - Oct 11 & 12, 2025",
      ];
    } else if (this.$store.state.eventInfo.VenueId == 2121) {
      this.items = [
        "Festival 1 - Sep 20 & 21, 2025",
        "Festival 2 - Sep 27 & 28, 2025",
      ];
    } else if (this.$store.state.eventInfo.VenueId == 2122) {
      this.items = [
        "Festival 1 - Sep 20 & 21, 2025",
        "Festival 2 - Oct 11 & 12, 2025",
      ];
    } else if (this.$store.state.eventInfo.VenueId == 2123) {
      this.items = [
        "Festival 1 - Sep 20 & 21, 2025",
        "Festival 2 - Oct 11 & 12, 2025",
      ];
    }
    this.dialog = true;
  },
  watch: {
    cbTnC: function (val) {
      if (val == false) {
        this.dialog = true;
      }
    },
    dialog: function (val) {
      if (val == false) {
        this.cbTnC = true;
      }
    },
  },
  methods: {
    showMsg: function (color, msg) {
      this.alert.color = color;
      this.alert.msg = msg;
      this.alert.show = true;
    },
    filterNum: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^\d+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    filterChar: function (evt) {
      evt = evt ? evt : window.event;
      if (
        (evt.charCode > 64 && evt.charCode < 91) ||
        (evt.charCode > 96 && evt.charCode < 123) ||
        evt.charCode == 32
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    createprofile: async function () {
      this.$refs.form.validate();
      if (this.formValid) {
        this.overlay = true;
        this.appData.vendor_id = this.$store.state.eventInfo.VendorId;
        this.appData.event_id = this.$store.state.eventInfo.EventId;
        this.appData.venue_id = this.$store.state.eventInfo.VenueId;
        await this.$axios
          .put("VendorApp/vendorCoordinator", this.appData)
          .then((res) => {
            if (res.data.status == "Success") {
              this.overlay = false;
              this.$router.push("/app/dashboard");
            }
          });
      }
    },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
.forcolor {
  color: black;
}
</style>
